import React from "react";
import { BlogLayout } from "@/components/layout/BlogLayout";
import { TableOfContents } from "@/components/blog/TableOfContents";
import { PostHeader } from "@/components/blog/PostHeader";
import { PostIntroSection } from "@/components/blog/PostIntroSection";
import { marketingDigitalPymesTableOfContents } from "./marketing-digital-pymes/tableOfContents";
import { ArticleContent } from "./marketing-digital-pymes/ArticleContent";
import { RelatedArticles } from "@/components/blog/RelatedArticles";
import { Breadcrumbs } from "@/components/shared/Breadcrumbs";
import { UpdateDate } from "@/components/shared/UpdateDate";
import blogImage from "@/assets/blog-marketing-digital-pymes.jpg";

export function MarketingDigitalPymesPost() {
  return (
    <>
      <PostHeader 
        title="Estrategias de Marketing Digital para Pequeñas Empresas: Guía Completa 2025 | SEOEVOLUTION"
        description="Descubre las mejores estrategias de marketing digital para pequeñas empresas: SEO, redes sociales, email marketing, publicidad online y Google My Business. Guía práctica con ejemplos."
        keywords="marketing digital pequeñas empresas, estrategias marketing digital pymes, SEO para negocios locales, email marketing efectivo, publicidad digital pequeñas empresas, marketing de contenido pymes, redes sociales para pymes, Google My Business optimización"
        author="Ángel Ruz"
        canonicalUrl="https://agenciaseoevolution.com/blog/marketing-digital-pequenas-empresas"
        datePublished="2025-02-15"
      />

      <BlogLayout>
        <article className="py-16 relative overflow-hidden" itemScope itemType="https://schema.org/Article">
          <meta itemProp="headline" content="Estrategias de Marketing Digital para Pequeñas Empresas: Guía Completa 2025" />
          <meta itemProp="author" content="Ángel Ruz" />
          <meta itemProp="datePublished" content="2025-02-15" />
          <meta itemProp="dateModified" content="2025-02-15" />
          
          <div className="absolute inset-0 bg-gradient-to-br from-seo-darkBlue to-seo-dark opacity-90"></div>
          <div className="container mx-auto px-4 md:px-6 relative z-10">
            <div className="max-w-5xl mx-auto">
              <Breadcrumbs />
              
              <PostIntroSection 
                category="MARKETING DIGITAL"
                title="Estrategias de Marketing Digital para Pequeñas Empresas: Guía Completa 2025"
                date="15 Febrero, 2025"
                author="Ángel Ruz"
                imageUrl={blogImage}
                imageAlt="Estrategias de marketing digital para pequeñas empresas: SEO, redes sociales, email marketing y publicidad online"
                description="El marketing digital se ha convertido en una herramienta esencial para las pequeñas empresas que buscan mantenerse competitivas. Las estrategias de marketing digital para PYMEs no solo ayudan a aumentar la visibilidad, sino que permiten conectar con los clientes de manera más efectiva y económica que los métodos tradicionales. En esta guía completa, exploraremos las mejores prácticas y estrategias que las pequeñas empresas pueden implementar para maximizar su presencia online y alcanzar sus objetivos comerciales."
              />

              <UpdateDate 
                date="Febrero 2025"
                updatesSection={
                  <div>
                    <p className="font-semibold mb-2">Tendencias 2025:</p>
                    <ul className="list-disc list-inside space-y-1 text-sm">
                      <li>IA generativa aplicada al marketing de contenidos</li>
                      <li>Google SGE cambia las estrategias SEO tradicionales</li>
                      <li>Vídeo corto (Reels/TikTok) lidera el engagement social</li>
                      <li>Automatización de email marketing con IA personalizada</li>
                    </ul>
                  </div>
                }
              />

              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div className="lg:col-span-2 bg-seo-dark/50 rounded-xl p-6 shadow-lg backdrop-blur-xs">
                  <ArticleContent />
                  <RelatedArticles currentSlug="/marketing-digital-pequenas-empresas" category="Marketing Digital" />
                </div>
                
                <div className="lg:col-span-1">
                  <TableOfContents items={marketingDigitalPymesTableOfContents} />
                </div>
              </div>
            </div>
          </div>
        </article>
      </BlogLayout>
    </>
  );
}
